// Eski WordPress sitesinin (flyexpress.com, 2026-10) adresleri. Saf modül: next.config.ts (yönlendirmeler),
// src/proxy.ts (410) ve birim testleri kullanır. Ayrıntı: docs/seo-and-redirects.md
//
// Türkçe sayfa adresleri yeni sitede aynen korunduğu için yönlendirme gerekmez. İngilizce sayfaların çoğu da
// aynı adreste (/en/about-us/ → /en/about-us; sondaki "/" Next.js tarafından 308 ile kaldırılır); farklı olanlar:

export type LegacyRedirect = { source: string; destination: string };

/** Eski İngilizce adres → yeni İngilizce karşılığı (kalıcı, 308) */
export const LEGACY_EN_REDIRECTS: LegacyRedirect[] = [
  { source: "/en/fly-cruise-2", destination: "/en/fly-cruise" },
  { source: "/en/fly-exclusive-2", destination: "/en/fly-exclusive" },
  { source: "/en/fly-elegant-2", destination: "/en/fly-elegant" },
  { source: "/en/fly-classic-2", destination: "/en/fly-classic" },
];

/** Eski sitede olup yeni sitede bilerek karşılığı olmayan WordPress uçları: 410 Gone (kalıcı olarak kaldırıldı) */
const GONE = [
  /^\/(?:en\/)?(?:comments\/)?feed(?:\/.*)?$/, // RSS: /feed/, /comments/feed/, /en/feed/
  /^\/wp-json(?:\/.*)?$/, // REST API
  /^\/xmlrpc\.php$/,
];

export function isGonePath(pathname: string): boolean {
  return GONE.some((re) => re.test(pathname));
}
